import ApplicationController from './application_controller.js'

// Enables the "send min price to provider" checkbox only when the selected provider
// is in the allow-list (passed in as the `allowed` value). When the provider is not
// allowed the checkbox is disabled and unchecked so we never submit `true` for a
// provider that can't receive min-price restrictions. The server-side `disabled:`
// attribute and the model validation remain the authoritative fallback.
export default class extends ApplicationController {
  static targets = ['provider', 'checkbox']
  static values = { allowed: Array }

  connect() {
    this.update()
  }

  update() {
    const allowed = this.allowedValue.includes(this.providerTarget.value)
    this.checkboxTarget.disabled = !allowed
    if (!allowed) {
      this.checkboxTarget.checked = false
    }
  }
}
